import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { BackgroundCarousel, useWindowDimensions } from "../common";

const useStyles = makeStyles((theme) => ({
  bgContainer: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    zIndex: -2,
  },
  backgroundCanvas: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    overflow: "hidden",
    zIndex: -2,
  },
  backgroundGreyCanvas: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#c8c8c8",
    overflow: "hidden",
    zIndex: -3,
  },
  paper: {
    height: "100vh",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "50px 10px",
    },
    padding: 50,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
}));

export default function OpeningLayout({ content }) {
  const classes = useStyles();
  const { height, width } = useWindowDimensions();

  /** @type {HTMLCanvasElement} */
  const canvasRef = React.useRef(null);
  React.useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas === null) return;
    /** @type {CanvasRenderingContext2D}*/
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#457B9D";
    ctx.rotate(0.167 * Math.PI);
    ctx.fillRect(
      -ctx.canvas.width / 2,
      -ctx.canvas.height * 1.55,
      ctx.canvas.width,
      ctx.canvas.height * 2
    );
    ctx.save();
    ctx.fillStyle = "#FFFFFF";
    ctx.rotate(-0.333 * Math.PI);
    ctx.fillRect(
      -ctx.canvas.width * 0.88,
      -ctx.canvas.width * 0.2,
      ctx.canvas.width * 1.2,
      3000
    );
    ctx.save();
  }, [canvasRef, width, height]);

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.backgroundGreyCanvas} />
      <div className={classes.bgContainer}>
        <BackgroundCarousel />
      </div>
      <canvas
        className={classes.backgroundCanvas}
        ref={canvasRef}
        width={window.innerWidth}
        height={window.innerHeight}
      />
      {content}
    </React.Fragment>
  );
}
